import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { DocumentHyperlink } from '../../components/DocumentHyperlink';
import { MainContainer } from "../../components/MainContainerComp";
import { JDAReportsData, JDAReportsSectorKeys, Rating } from "./JDAReportsData";
import { JDAReportsSector } from './JDAReportsModel';
import { Disclaimer } from './components/Disclaimer';
import { PdfLinkStyle, SelectMenuStyle, asteriskStyle, descriptionStyle, disclaimerContainerStyle, disclaimerContentStyle, disclaimerIconStyle, disclaimerStyle, selectStyle } from "./styled";

export interface JDAReportsProps {
  data: JDAReportsData,
  onShowDisclaimer: () => void,
  showDisclaimer: boolean,
  sector: JDAReportsSectorKeys,
  onSelectSector: (sector: JDAReportsSectorKeys) => void,
  job: Rating,
  onSelectJob: (job: Rating | undefined) => void,
}

export const JDAReports = ({
  data,
  onShowDisclaimer,
  showDisclaimer,
  sector,
  onSelectSector,
  job,
  onSelectJob
}: JDAReportsProps) => {
  const report = data.jdaReports.find(r => r.key === job.key);
  return (
    <MainContainer>
      {showDisclaimer &&
        <Box sx={disclaimerContainerStyle}>
          <Box sx={disclaimerContentStyle}>
            <Disclaimer onClick={onShowDisclaimer} />
          </Box>
        </Box>
      }
      <Box
        sx={disclaimerStyle}
        onClick={onShowDisclaimer}
      >
        <ErrorOutlineRoundedIcon sx={disclaimerIconStyle} />
        <Typography data-automation="JDA-disclaimer-link"> Job Demand Analysis Report Details</Typography>
      </Box>
      <Grid container>
        <Grid item xs={12} sm={8} md={6}>
          <Typography data-automation="sector-title">
            Sector<Typography component={"span"} sx={asteriskStyle}>&nbsp;*</Typography>
          </Typography>
          <Select
            sx={selectStyle}
            displayEmpty
            value={sector}
            onChange={e => onSelectSector(e.target.value as JDAReportsSectorKeys)}
            MenuProps={{ sx: SelectMenuStyle }}
            data-automation="sector-drop-down"
          >
            {
              Object.values(JDAReportsSector).map(s => (
                <MenuItem key={s} value={Object.keys(JDAReportsSector)[Object.values(JDAReportsSector).indexOf(s)]}>
                  {s}
                </MenuItem>
              ))
            }
          </Select>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={8} md={6}>
          <Typography data-automation="job-title">
            Job<Typography component={"span"} sx={asteriskStyle}>&nbsp;*</Typography>
          </Typography>
          <Select
            sx={selectStyle}
            displayEmpty
            value={job.key}
            onChange={e => onSelectJob(data.ratings.find(r => r.key === e.target.value))}
            MenuProps={{ sx: SelectMenuStyle }}
            data-automation="job-drop-down"
          >
            {
              data.ratings.map(j => (
                <MenuItem key={j.key} value={j.key} sx={{ whiteSpace: 'normal' }}>{j.rating}</MenuItem>
              ))
            }
          </Select>
        </Grid>
      </Grid>
      <Typography
        component={'div'} 
        variant='container' 
        data-automation="data-container"
      >
        <DocumentHyperlink
          styles={PdfLinkStyle}
          title='PDA'
          link={report?.pdaLink || '#'}
          dataAutomation='PDA-pdf'
        />
        <DocumentHyperlink
          styles={PdfLinkStyle}
          title='MD Summary'
          link={report?.mdLink || '#'}
          dataAutomation='MD-pdf'
        />
        <Typography sx={descriptionStyle} data-automation="job-description">
          {report?.description}
        </Typography>
      </Typography>
    </MainContainer>
  )
}